import { render, staticRenderFns } from "./video-chunk-upload.vue?vue&type=template&id=48024813"
import script from "./video-chunk-upload.vue?vue&type=script&lang=js"
export * from "./video-chunk-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports